// Model.js
// -----------------------
// @module Case
define("NVT.AssociateMembershipForm.AssoMembForm.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/AssoMembForm/SuiteScript2/AssoMembForm.Service.ss"
            ),
            true
        )
});
});
